// import { Icon } from 'antd';
import { SmileOutlined } from '@ant-design/icons';

export default (
  <SmileOutlined type="smile" rotate={180} style={{ color: 'red' }} />
);
